import httpClient from "../utilis/jwtRequest";
import createFormData from "../utilis/formDataHelper";

const PARTNERS_URL = "/Partners/";

function getAllPartners() {
  return httpClient.get(PARTNERS_URL);
}
function add(newPartner) {
  const formData = createFormData(newPartner);
  return httpClient.post(PARTNERS_URL, formData);
}
function getPartnerById(id) {
  return httpClient.get(PARTNERS_URL + `${id}/`);
}
function updatePartner(id, newPartner) {
  const formData = createFormData(newPartner);
  return httpClient.put(PARTNERS_URL + `${id}/`, formData);
}
function deletePartner(id) {
  return httpClient.delete(PARTNERS_URL + `${id}/`);
}

export const partnersService = {
  getAllPartners,
  add,
  getPartnerById,
  updatePartner,
  deletePartner,
};

